<script>
  import { fade, scale } from 'svelte/transition';
  import { expoOut } from 'svelte/easing'; // 引入缓动函数
  import { CircleCheck, CircleAlert, Info, LoaderCircle } from "@lucide/svelte"; 
  import { toast } from "./toast.svelte.js";

  const icons = {
    success: { component: CircleCheck, color: "text-white-400" },
    error: { component: CircleAlert, color: "text-white-400" },
    info: { component: Info, color: "text-white-400" },
    loading: { component: LoaderCircle , color: "text-white animate-spin" }
  };

  let currentIcon = $derived(icons[toast.current.type]);
</script>

{#if toast.current.visible}
  <div class="fixed inset-0 z-[1000] flex items-center justify-center pointer-events-none p-4">
    <!-- 进入动画：从 0.85 缩放到 1，配合 expoOut 曲线，会有那种从屏幕深处跳出来的感觉 */
       消失动画：简单的淡出即可，时间短一点，显得干脆 -->
    <div 
      in:scale={{ duration: 400, start: 0.85, opacity: 0, easing: expoOut }} 
      
      out:fade={{ duration: 200 }}
      class="flex flex-col items-center min-w-[140px] gap-3 px-8 py-6 bg-zinc-900/90 backdrop-blur-xl border border-white/10 text-white rounded-[1.5rem] shadow-2xl opacity-90"
    >
      <div class="flex flex-col items-center gap-3">
        <currentIcon.component
          size={32} 
          strokeWidth={2.5}
          class={currentIcon.color}
        />
        <p class="text-sm font-semibold tracking-wide text-center leading-relaxed">
          {toast.current.message}
        </p>
      </div>
    </div>
  </div>
{/if}